import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import st from './AddClient.module.scss'
import { localisationMaster } from 'Localisation/Localisation'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import FormSelectCustom from 'components/UI/AsideModal/Form/FormSelectCustom'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import useLocalization from 'hooks/useLocalization'

const AddClient = ({ edit }) => {
  const { modalValues: modalValue, changeValue, check } = asideModalStore

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      phone_number: 'Phone number',
      name: 'Name',
      inn_iin: 'INN/IIN',
      level: 'Level',
      comment: 'Comment',
    },
  })

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  const handlerInnChange = (e) => {
    const { value } = e.target
    const filteredValue = value.replace(/\D/g, '')
    const limitedValue = filteredValue.slice(0, 12)
    changeValue(limitedValue, 'inn')
  }

  return (
    <div className={st.groupForm}>
      <FormField>
        <FormLabel isRequired>{translate?.name}:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            type='text'
            placeholder={translate?.name}
            name='name'
            value={modalValue.name || ''}
            onChange={handleInputChange}
            maxLength={35}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>{translate?.phone_number}:</FormLabel>
        <InputFlagPhone
          error={check('phone')}
          value={modalValue.phone || modalValue.whatsapp || ''}
          onChange={(val) => changeValue(val, 'phone')}
        />
      </FormField>
      <FormField>
        <FormLabel>{'Email:'}</FormLabel>
        <FormInput isError={check('email')}>
          <input
            type='email'
            placeholder={'Email'}
            name='email'
            value={modalValue.email || ''}
            onChange={(e) => changeValue(e.target.value, 'email')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>{translate?.inn_iin}:</FormLabel>
        <FormInput isError={check('inn')}>
          <input
            type='text'
            placeholder={translate?.inn_iin}
            name='inn'
            value={modalValue.inn || ''}
            //onChange={e => changeValue(e.target.value, 'inn')}
            onChange={handlerInnChange}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>{'WhatsApp:'}</FormLabel>
        <InputFlagPhone
          error={check('whatsapp')}
          value={modalValue.whatsapp || ''}
          onChange={(val) => changeValue(val, 'whatsapp')}
        />
      </FormField>
      <FormField>
        <FormLabel>{'Instagram:'}</FormLabel>
        <FormInput isError={check('company')}>
          <input
            type='text'
            placeholder={'Instagram'}
            name='instagram'
            value={modalValue.instagram || ''}
            onChange={(e) => changeValue(e.target.value, 'instagram')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>{'Telegram:'}</FormLabel>
        <FormInput isError={check('telegram')}>
          <input
            type='text'
            placeholder={'Telegram'}
            name='telegram'
            value={modalValue.telegram || ''}
            onChange={(e) => changeValue(e.target.value, 'telegram')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>{translate?.level}:</FormLabel>
        {/*<FormInput isError={check('level')}>*/}
        {/*    <input type="text"*/}
        {/*           placeholder={"Level"}*/}
        {/*           name="level"*/}
        {/*           value={modalValue.level || ''}*/}
        {/*           onChange={e => changeValue(e.target.value, 'level')}*/}
        {/*    />*/}
        {/*</FormInput>*/}
        <FormSelectCustom>
          <SelectCustom
            placeholder={translate?.level}
            valueID={modalValue.level}
            //onChange={o => changeTypeHandler(o.value)}
            error={check('level')}
            //isDisabled={ms.is_put}
          />
        </FormSelectCustom>
      </FormField>
      <FormField>
        <FormLabel>
          {localisationMaster('table-row-title-2', 'company/companies')}:
        </FormLabel>
        <textarea
          onChange={(e) => changeValue(e.target.value, 'comment')}
          value={modalValue.comment}
          placeholder={translate?.comment}
        />
      </FormField>
    </div>
  )
}

export default observer(AddClient)
